import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { AnimationController, IonicModule, ModalController } from '@ionic/angular';
import { IFileResponse } from '@api/client';
import { buildAvatarSvgDataUrl } from '@utils/initials';
import { createCenterModalAnimations } from '@utils/modal-animations';
import { StateOverlayService } from '@state-routing/public-api';

@Component({
  selector: 'user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    IonicModule
  ]
})
export class UserAvatarComponent {
  private readonly modalController = inject(ModalController);
  private readonly stateOverlay = inject(StateOverlayService);
  private readonly animationController = inject(AnimationController);

  @Input() public fullName: string = '';
  @Input() public avatarUrl?: string;
  @Input() public avatarFile?: IFileResponse;
  @Input() public typeAvatar: 'default' | 'with-light' | 'user-offline' | 'user-online' = 'default'; // not used
  @Input() public sizeLight: 'big' | 'medium' | 'small' | 'none' | 'super-big' = 'small'; // not used
  @Input() public showOriginalByClick: boolean = true; // not used
  @Input() public userId?: number;
  @Input() public nickname?: string;
  @Input() public official: boolean = false;
  @Input() public enableContactCard: boolean = false;

  protected readonly buildAvatarSvgDataUrl = buildAvatarSvgDataUrl;
  protected isImageError: boolean = false;

  @HostBinding('class.contact-card-enabled')
  protected get contactCardEnabled(): boolean {
    return this.enableContactCard && (!!this.userId || !!this.nickname);
  }

  protected get avatarImageUrl(): string | null {
    return this.avatarUrl || this.avatarFile?.resizes?.[0]?.url || null;
  }

  // get File(): any {
  //   return {
  //     resizes: this.avatarFile.resizes,
  //     type: {id: 3, name: 'image'},
  //     name: this.name,
  //     origin: this.avatarFile.origin
  //   };
  // }

  // showImage(imageSlider, event) {
  //   if(this.showOriginalByClick) {
  //     event.stopImmediatePropagation();
  //     imageSlider.showImages([this.File], 0);
  //   }
  // }

  protected markImageAsBad(): void {
    this.isImageError = true;
  }

  protected async onAvatarClick(event: Event): Promise<void> {
    if (!this.enableContactCard || (!this.userId && !this.nickname)) return;
    if (typeof window === 'undefined') return;

    event?.stopPropagation();
    event?.preventDefault();

    const { ContactCardComponent } = await import('@ui-components/contact-card/contact-card.component');
    const { enterAnimation, leaveAnimation } = createCenterModalAnimations(this.animationController, {
      fromScale: 0.9,
      duration: 200,
    });
    const modal = await this.modalController.create({
      component: ContactCardComponent,
      componentProps: {
        userId: this.userId,
        nickname: this.nickname,
        fullName: this.fullName,
        avatarUrl: this.avatarUrl,
        avatarFile: this.avatarFile,
        official: this.official,
        isOnline: this.typeAvatar === 'user-online',
      },
      cssClass: 'contact-card-modal',
      showBackdrop: true,
      backdropDismiss: true,
      enterAnimation,
      leaveAnimation,
    });

    await modal.present();
    this.stateOverlay.register(modal);
  }
}
